import { ChangeDetectorRef, Component, Input, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { TableColumn } from 'src/app/modules/shared/table/table.component';
import { authIndvTable, powerIndvTable, shareholderIndvTable } from '../../individuals';

@Component({
    selector: 'app-linkages-individual',
    templateUrl: './linkages-individual.component.html',
    styleUrls: ['./linkages-individual.component.scss'],
    standalone: false
})
export class LinkagesIndividualComponent implements OnChanges {

  @Input() linkages;
  @Input() individual_fullname = '';

  powerTable: TableColumn[] = powerIndvTable;
  shareholderTable: TableColumn[] = shareholderIndvTable;
  authTable: TableColumn[] = authIndvTable;

  powersLinks: any[] = [];
  powersOldLinks: any[] = [];
  shareholderLinks: any[] = [];
  authLinks: any[] = [];

  currentPower = 'new';
  openSection: string | null = null;

  constructor(private router: Router, private ref: ChangeDetectorRef) { }

  ngOnChanges(): void {
    if (this.linkages) {
      this.powersLinks = this.linkages.powers_companies || [];
      this.powersOldLinks = this.linkages.powers_old_companies || [];
      this.shareholderLinks = this.linkages.stock_companies || [];
      this.authLinks = this.linkages.authorities_companies || [];
      this.ref.markForCheck();
    }
  }

  toggleSection(section: string): void {
    this.openSection = this.openSection === section ? null : section;
  }

  getPowersLinks(): any[] {
    return this.currentPower === 'new' ? this.powersLinks : this.powersOldLinks;
  }

  getPowersCount(): number {
    return this.getPowersLinks()?.length || 0;
  }

  handleClick(e, type) {
    switch (e.action) {
      case 'navigate':
        if (type === 'shareholder' || type === 'directory') {
          this.router.navigateByUrl(`/company/${e?.payload?.company_id}/${type}`);
        } else {
          this.router.navigateByUrl(`/upload/edit/${e?.payload?.company_id}/${type}/${e?.payload?.id}`);
        }
        break;
    }
  }

  toggleView(selection) {
    this.currentPower = selection;
    this.ref.markForCheck();
  }
}
